module.exports = __webpack_public_path__ + "img/肃宁皮毛.4b52ecb1.jpg";